import { render, staticRenderFns } from "./QImpersonateAccount.vue?vue&type=template&id=7c90dece&scoped=true&"
import script from "./QImpersonateAccount.vue?vue&type=script&lang=js&"
export * from "./QImpersonateAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c90dece",
  null
  
)

export default component.exports